// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__S8ZYS","slider":"style_slider__K1d4A","round":"style_round__6ame0","containerButton":"style_containerButton__4mM4U"};